
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4Lxwo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e097dac809a576c3$export$b027791af8c9b114 = (initialIndex = 0)=>{
    const [activeIndex, setActiveIndex] = (0, $cozmU.useState)(initialIndex);
    const handleTabClick = (0, $cozmU.useCallback)((index)=>{
        setActiveIndex(index);
    }, []);
    return {
        activeIndex: activeIndex,
        handleTabClick: handleTabClick
    };
};
module.exports["useActiveTab"] = $e097dac809a576c3$export$b027791af8c9b114;

});

parcelRegister("fpoR3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPJCf = parcelRequire("dPJCf");


var $96TFz = parcelRequire("96TFz");

const $2d67f08b0ec377d6$var$EXTENSION_FRAME_SELECTOR = '[data-extension-frame="true"]';
const $2d67f08b0ec377d6$var$decodeHashId = (rawHash)=>{
    if (!rawHash) return null;
    try {
        return decodeURIComponent(rawHash);
    } catch  {
        return rawHash;
    }
};
const $2d67f08b0ec377d6$var$findElementById = (root, id)=>{
    if (typeof CSS !== 'undefined' && CSS.escape) return root.querySelector(`#${CSS.escape(id)}`);
    return Array.from(root.querySelectorAll('[id]')).find((element)=>element.id === id) ?? null;
};
const $2d67f08b0ec377d6$var$findAnchorByName = (root, name)=>Array.from(root.querySelectorAll('a[name]')).find((anchor)=>anchor.getAttribute('name') === name) ?? null;
const $2d67f08b0ec377d6$var$findElementByHash = (root, hashId, resolveElementByHash)=>{
    const element = $2d67f08b0ec377d6$var$findElementById(root, hashId) ?? $2d67f08b0ec377d6$var$findAnchorByName(root, hashId) ?? resolveElementByHash?.(hashId) ?? null;
    return element && root.contains(element) ? element : null;
};
const $2d67f08b0ec377d6$var$getExtensionFrameIndex = (element)=>{
    const frame = element.closest($2d67f08b0ec377d6$var$EXTENSION_FRAME_SELECTOR);
    const frameParent = frame?.parentElement;
    if (!frame || !frameParent) return -1;
    const frames = Array.from(frameParent.querySelectorAll(`:scope > ${$2d67f08b0ec377d6$var$EXTENSION_FRAME_SELECTOR}`));
    return frames.indexOf(frame);
};
const $2d67f08b0ec377d6$var$scrollElementIntoViewAfterFrameActivation = (element)=>{
    requestAnimationFrame(()=>element.scrollIntoView());
};
const $2d67f08b0ec377d6$export$a00fe2f5000515e1 = ({ tabs: tabs, activeIndex: activeIndex, onTabSelect: onTabSelect, rootRef: rootRef, resolveElementByHash: resolveElementByHash, resolveFrameIndexByHash: resolveFrameIndexByHash })=>{
    const routeHash = (0, $dPJCf.useHash)();
    const activeIndexRef = (0, $cozmU.useRef)(activeIndex);
    const lastProcessedRouteHashRef = (0, $cozmU.useRef)(null);
    const pendingFrameScrollRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        activeIndexRef.current = activeIndex;
    }, [
        activeIndex
    ]);
    (0, $cozmU.useEffect)(()=>{
        const pendingFrameScroll = pendingFrameScrollRef.current;
        if (!pendingFrameScroll) return;
        if (pendingFrameScroll.frameIndex !== activeIndex) {
            pendingFrameScrollRef.current = null;
            return;
        }
        // The target frame is now active, so the heading is visible enough to scroll to.
        pendingFrameScrollRef.current = null;
        $2d67f08b0ec377d6$var$scrollElementIntoViewAfterFrameActivation(pendingFrameScroll.element);
    }, [
        activeIndex
    ]);
    const scrollElementWhenFrameIsActive = (0, $cozmU.useCallback)((element, frameIndex)=>{
        if (activeIndexRef.current === frameIndex) {
            $2d67f08b0ec377d6$var$scrollElementIntoViewAfterFrameActivation(element);
            return;
        }
        pendingFrameScrollRef.current = {
            element: element,
            frameIndex: frameIndex
        };
    }, []);
    const activateHashTab = (0, $cozmU.useCallback)((hashId, { shouldScroll: shouldScroll = true } = {})=>{
        if (!hashId) return false;
        const tabIndex = tabs.findIndex((tab)=>(0, $96TFz.getTabTitleHash)(tab.title) === hashId);
        const root = rootRef?.current;
        if (tabIndex !== -1) {
            onTabSelect(tabIndex);
            if (shouldScroll) {
                if (root) $2d67f08b0ec377d6$var$findElementById(root, tabs[tabIndex].id)?.scrollIntoView();
            }
            return true;
        }
        if (root) {
            const targetElement = $2d67f08b0ec377d6$var$findElementByHash(root, hashId, resolveElementByHash);
            if (targetElement) {
                const frameIndex = $2d67f08b0ec377d6$var$getExtensionFrameIndex(targetElement);
                if (frameIndex === -1 || frameIndex >= tabs.length) return false;
                onTabSelect(frameIndex);
                if (shouldScroll) scrollElementWhenFrameIsActive(targetElement, frameIndex);
                return true;
            }
        }
        if (!resolveFrameIndexByHash) return false;
        const frameIndex = resolveFrameIndexByHash(hashId);
        if (frameIndex === -1 || frameIndex >= tabs.length) return false;
        onTabSelect(frameIndex);
        return true;
    }, [
        onTabSelect,
        resolveElementByHash,
        resolveFrameIndexByHash,
        rootRef,
        scrollElementWhenFrameIsActive,
        tabs
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (lastProcessedRouteHashRef.current === routeHash) return;
        lastProcessedRouteHashRef.current = routeHash;
        const hashId = $2d67f08b0ec377d6$var$decodeHashId(routeHash);
        if (!hashId) return;
        activateHashTab(hashId);
    }, [
        activateHashTab,
        routeHash
    ]);
};
module.exports["useHashNavigation"] = $2d67f08b0ec377d6$export$a00fe2f5000515e1;

});

parcelRegister("96TFz", function(module, exports) {
const $9c4f95c2e0489d27$export$4d0126a4588e0f9d = (title)=>{
    const hash = title.trim().replace(/\s/g, '-');
    return hash || null;
};
module.exports["getTabTitleHash"] = $9c4f95c2e0489d27$export$4d0126a4588e0f9d;

});

parcelRegister("7QgC6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kcIQr = parcelRequire("kcIQr");


var $56j2k = parcelRequire("56j2k");

const $9f641b44a256292c$var$sourceByMode = {
    editor: 'editPageScreen',
    renderer: 'viewPageScreen'
};
const $9f641b44a256292c$export$41e895c32f867cc4 = ({ mode: mode })=>{
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        createEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro',
                actionSubjectId: (0, $56j2k.EXTENSION_KEY),
                source: $9f641b44a256292c$var$sourceByMode[mode],
                attributes: {
                    extensionType: (0, $56j2k.EXTENSION_TYPE)
                }
            }
        }).fire();
        hasFiredRef.current = true;
    }, [
        createEvent,
        mode
    ]);
};
module.exports["useViewedAnalytics"] = $9f641b44a256292c$export$41e895c32f867cc4;

});

parcelRegister("f8kIu", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

const $6e41d91fddf150ca$var$ANCHOR_EXTENSION_KEY = 'anchor';
const $6e41d91fddf150ca$var$ANCHOR_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';
const $6e41d91fddf150ca$var$getStringParamValue = (param)=>typeof param?.value === 'string' ? param.value : null;
const $6e41d91fddf150ca$export$8d5224dfa4e280c0 = (rawValue)=>rawValue.replaceAll(/[%"'\s]/g, '');
const $6e41d91fddf150ca$var$isAnchorMacroNode = (node)=>{
    const attrs = node.attrs;
    return attrs?.extensionKey === $6e41d91fddf150ca$var$ANCHOR_EXTENSION_KEY && attrs.extensionType === $6e41d91fddf150ca$var$ANCHOR_EXTENSION_TYPE;
};
const $6e41d91fddf150ca$var$anchorMacroMatchesHash = (node, hashId)=>{
    if (!$6e41d91fddf150ca$var$isAnchorMacroNode(node)) return false;
    const macroParams = node.attrs?.parameters?.macroParams;
    const anchorName = $6e41d91fddf150ca$var$getStringParamValue(macroParams?.['']);
    const legacyAnchorName = $6e41d91fddf150ca$var$getStringParamValue(macroParams?.legacyAnchorId);
    return(// AnchorExtensionHandler strips these characters before rendering the current anchor name.
    anchorName !== null && $6e41d91fddf150ca$export$8d5224dfa4e280c0(anchorName) === hashId || // legacyAnchorId is already the stored URL fragment and is rendered without extra sanitizing.
    legacyAnchorName === hashId);
};
const $6e41d91fddf150ca$var$frameContainsAnchorHash = (frame, hashId)=>{
    let hasMatch = false;
    const visitExtension = (node)=>{
        if (hasMatch) return;
        hasMatch = $6e41d91fddf150ca$var$anchorMacroMatchesHash(node, hashId);
    };
    (0, $jTt8P.traverse)(frame, {
        inlineExtension: visitExtension
    });
    return hasMatch;
};
const $6e41d91fddf150ca$export$8e1955da4ccd68b3 = (frames, hashId)=>{
    if (!Array.isArray(frames) || !frames.length || !hashId) return -1;
    // Find which Native Tabs frame owns the Anchor macro without relying on rendered DOM.
    return frames.findIndex((frame)=>$6e41d91fddf150ca$var$frameContainsAnchorHash(frame, hashId));
};
module.exports["findAnchorMacroFrameIndexByHash"] = $6e41d91fddf150ca$export$8e1955da4ccd68b3;

});

parcelRegister("klwje", function(module, exports) {
/* NativeTabs.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $4QfFX = parcelRequire("4QfFX");


var $4Vdlk = parcelRequire("4Vdlk");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $k6Q5P = parcelRequire("k6Q5P");

const $c59ce8ad53c75e90$export$f49ff9a54a0d489e = 'native-tab';
function $c59ce8ad53c75e90$export$352e4484cda9b022(pointerPosition, wrappers, orientation = 'horizontal') {
    if (wrappers.length === 0) return null;
    const axis = (0, $k6Q5P.getTabAxis)(orientation);
    let closestIndex = 0;
    let closestEdge = axis.startEdge;
    let closestDistance = Infinity;
    wrappers.forEach((el, index)=>{
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const start = rect[axis.rectStart];
        const end = rect[axis.rectEnd];
        const startDistance = Math.abs(pointerPosition - start);
        const endDistance = Math.abs(pointerPosition - end);
        if (startDistance < closestDistance) {
            closestDistance = startDistance;
            closestIndex = index;
            closestEdge = axis.startEdge;
        }
        if (endDistance < closestDistance) {
            closestDistance = endDistance;
            closestIndex = index;
            closestEdge = axis.endEdge;
        }
    });
    return closestDistance === Infinity ? null : {
        index: closestIndex,
        edge: closestEdge
    };
}





/* TabBar.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $9kbTQ = parcelRequire("9kbTQ");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $j6vyT = parcelRequire("j6vyT");


var $1LXnB = parcelRequire("1LXnB");


var $1sCHt = parcelRequire("1sCHt");





var $gFEZF = parcelRequire("gFEZF");


var $9EfQi = parcelRequire("9EfQi");








var $deUyp = parcelRequire("deUyp");


var $1bRPL = parcelRequire("1bRPL");


var $38vK5 = parcelRequire("38vK5");


var $endUL = parcelRequire("endUL");


var $ez93V = parcelRequire("ez93V");


var $vZEJe = parcelRequire("vZEJe");





var $hBYtq = parcelRequire("hBYtq");





/* TabDragPreview.tsx generated by @compiled/babel-plugin v3.0.2 */ 





const $9bc14a5cc51e8486$var$styles = {
    preview: "_0bjKvDS5Zs _2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _4c065UgVvo _2Y7lL48HPE _3vBAKHrzt2 _3hxITi6wH8 _2V7sgONvrM _0KLXruY9q9 _1UtDYzjTy9 _1kk5Tkf7mX _1ANEUSLRg7 _1EqgXlJYcJ _39HuIbz8Lp _2OUyjtzwhj"
};
const $9bc14a5cc51e8486$export$d6c426749d4e8e80 = ({ title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9bc14a5cc51e8486$var$styles.preview
    }, title);
};


/* TabPill.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $6OpMl = parcelRequire("6OpMl");







/* TabPillColorSurface.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $ipqo7 = parcelRequire("ipqo7");


var $ihDzO = parcelRequire("ihDzO");

const $b599b35381503a14$var$styles = {
    root: "_2sNsIgmnOE _0bjKvDS5Zs _4bt5LAYvD1 _2WAcuGYvD1 _23rrnHoacQ _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VUofl _20VacPYbGa _1ubuxonXvL _1NDpvb6wH8 _2wtOC9vc3e _34b3D2FQfX _0ReiIH7zJH",
    vertical: "_4c065U1Y8M _0jFU0VIZbP _4kiQYAUofl _1EqgXlJYcJ _4ouGXIdnbC _24h04i2Njc _37wbyuchRC",
    verticalRadiusStart: "_4e3HrduMRm _4GgNwsuMRm",
    verticalRadiusEnd: "_0mcu6juMRm _3kIZMxuMRm",
    activeWithMenu: "_0mcu6jdnbC _3kIZMxdnbC _3kN2LCdnbC _03SyCPgVvo",
    deletePreview: "_3vBAKHnod9 _0KLXruhH7k _1UtDYzAyGJ",
    defaultActive: "_3vBAKHrzt2 _2V7sgOvc3e _0KLXruY9q9 _1UtDYzjTy9",
    defaultInactive: "_3vBAKH9r67 _0KLXru66of _1UtDYzZpcK _1eOmH6o126",
    coloredActive: "_3vBAKHJDWa _2V7sgOvc3e _0KLXru7yHP _1UtDYziIOk",
    coloredInactive: "_3vBAKHJDWa _0KLXru7yHP _1UtDYziIOk _1eOmH6g45x"
};
const $b599b35381503a14$export$c9c4bba9e22a634c = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, color: color, id: id, isActive: isActive, isDeletePreviewed: isDeletePreviewed, isEditing: isEditing, onClick: onClick, onKeyDown: onKeyDown, orientation: orientation = 'horizontal', showMenu: showMenu, tabIndex: tabIndex }, ref)=>{
    const appearanceMode = (0, $ihDzO.isStandardTabColorPaletteEnabled)() ? 'standard' : 'legacy';
    const tabPillColor = color ? (0, $ipqo7.getTabColorAppearance)(color, appearanceMode).tabPill : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        id: id,
        testId: `native-tabs-pill-${id}`,
        ref: isEditing ? undefined : ref,
        role: isEditing ? undefined : 'tab',
        "aria-selected": isEditing ? undefined : isActive,
        "aria-controls": isEditing ? undefined : `panel-${id}`,
        tabIndex: isEditing ? undefined : tabIndex,
        onClick: isEditing ? undefined : onClick,
        onKeyDown: isEditing ? undefined : onKeyDown,
        style: {
            '--tab-pill-background-color': tabPillColor ? isActive ? tabPillColor.active.backgroundColor : tabPillColor.inactive.backgroundColor : undefined,
            '--tab-pill-background-color-hovered': tabPillColor?.inactive.backgroundColorHovered,
            '--tab-pill-border-color': tabPillColor ? isActive ? tabPillColor.active.borderColor : tabPillColor.inactive.borderColor : undefined,
            '--tab-pill-text-color': tabPillColor ? isActive ? tabPillColor.active.textColor : tabPillColor.inactive.textColor : undefined
        },
        xcss: (0, $w6R6I.cx)($b599b35381503a14$var$styles.root, !tabPillColor && isActive && $b599b35381503a14$var$styles.defaultActive, !tabPillColor && !isActive && $b599b35381503a14$var$styles.defaultInactive, tabPillColor && isActive && $b599b35381503a14$var$styles.coloredActive, tabPillColor && !isActive && $b599b35381503a14$var$styles.coloredInactive, isDeletePreviewed && $b599b35381503a14$var$styles.deletePreview, isActive && showMenu && $b599b35381503a14$var$styles.activeWithMenu, orientation === 'vertical' && $b599b35381503a14$var$styles.vertical, orientation === 'vertical' && $b599b35381503a14$var$styles.verticalRadiusStart, orientation === 'vertical' && !(isActive && showMenu) && $b599b35381503a14$var$styles.verticalRadiusEnd)
    }, children);
});
$b599b35381503a14$export$c9c4bba9e22a634c.displayName = 'TabPillColorSurface';


// Editor selected-node styles add a border and blanket to any emoji inside the selected extension.
// Tab labels use emoji as decorative pill content, so the pill should own the selected state instead.
const $28754f1172ac39f2$var$emojiSelectionOverride = `
[data-native-tabs-emoji] [data-emoji-type] {
	box-shadow: none !important;
}

[data-native-tabs-emoji] [data-emoji-type]::before {
	content: none !important;
}
`;
const $28754f1172ac39f2$var$styles = {
    editableTitle: "_0wOv4QJxkL",
    verticalTitle: "_3iDTPbvLZJ _4ouGXIdnbC _3zvHkHdC7N _2fwxA57p2s _1ANEUSzUZr",
    titleInput: "_2sNsIgmnOE _2XghbEPgdg _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4FKVYEPgdg _2V7sgOdnbC _0KLXrujOvk _0wOv4QJxkL _3iHkq9a6YE _4ouGXIUofl _1UtDYz98eZ",
    verticalTitleEditor: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _3iDTPbgBM8 _4ouGXIdnbC _1EqgXlN91d",
    verticalTitleSizer: "_2sNsIgmnOE _2EmVEz7dHp _1EKLiy7dHp _0fKRyPnQyn",
    verticalTitleTextarea: "_4bt5LAnQyn _2WAcuGnQyn _2EmVEz7dHp _1EKLiy7dHp _3iHkq9y1CL _39xV02dnbC _24h04i2Njc _4ouGXIN91d _3zvHkHdC7N _2HIj7GYbGa _1ANEUSzUZr",
    emoji: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _0adFHsgVvo"
};
const $28754f1172ac39f2$export$78d1357ca0402517 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ title: title, isActive: isActive, onClick: onClick, id: id, tabIndex: tabIndex = 0, showMenu: showMenu = false, emoji: emoji, emojiProvider: emojiProvider, onEmojiClick: onEmojiClick, canRename: canRename = false, isEditing: isEditing = false, isDeletePreviewed: isDeletePreviewed = false, onTitleEditStart: onTitleEditStart, onTitleEditSave: onTitleEditSave, onTitleEditCancel: onTitleEditCancel, color: color, orientation: orientation = 'horizontal' }, ref)=>{
    const emojiRef = (0, $cozmU.useRef)(null);
    const inputRef = (0, $cozmU.useRef)(null);
    const isCancellingRef = (0, $cozmU.useRef)(false);
    const isCommittingRef = (0, $cozmU.useRef)(false); // Only show the focus ring when focus returns after a keyboard-started edit.
    const isEditStartedWithKeyboardRef = (0, $cozmU.useRef)(false);
    const [draftTitle, setDraftTitle] = (0, $cozmU.useState)(title);
    (0, $cozmU.useEffect)(()=>{
        if (!isEditing) return;
        setDraftTitle(title);
        isCancellingRef.current = false;
        isCommittingRef.current = false;
        inputRef.current?.focus();
        inputRef.current?.select();
    }, [
        isEditing,
        title
    ]);
    const handleClick = (event)=>{
        if (onEmojiClick && isActive && emojiRef.current && emojiRef.current.contains(event.target)) {
            event.stopPropagation();
            onEmojiClick();
            return;
        }
        if (canRename) {
            event.stopPropagation();
            setDraftTitle(title);
            onTitleEditStart?.();
            return;
        }
        onClick(event);
    };
    const handleDraftChange = (event)=>{
        // Titles are single-line; pasted line breaks into the vertical textarea become spaces.
        setDraftTitle(event.currentTarget.value.replace(/[\r\n]+/g, ' '));
    };
    const handleDraftKeyDown = (event)=>{
        event.stopPropagation();
        if (event.key === 'Enter') {
            event.preventDefault();
            isCommittingRef.current = true;
            onTitleEditSave?.(event.currentTarget.value, {
                shouldRestoreFocus: true,
                focusVisible: isEditStartedWithKeyboardRef.current
            });
            return;
        }
        if (event.key === 'Escape') {
            event.preventDefault();
            isCancellingRef.current = true;
            onTitleEditCancel?.({
                focusVisible: isEditStartedWithKeyboardRef.current
            });
        }
    };
    const handleDraftBlur = (event)=>{
        if (isCommittingRef.current) {
            isCommittingRef.current = false;
            return;
        }
        if (isCancellingRef.current) {
            isCancellingRef.current = false;
            return;
        }
        onTitleEditSave?.(event.currentTarget.value);
    };
    const emojiContent = (0, $cozmU.useMemo)(()=>emoji && emojiProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", null, $28754f1172ac39f2$var$emojiSelectionOverride), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: emojiRef,
            xcss: $28754f1172ac39f2$var$styles.emoji,
            "data-native-tabs-emoji": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
            emojiProvider: emojiProvider,
            emojiId: {
                id: emoji,
                shortName: emoji
            },
            fitToHeight: 20,
            showTooltip: false
        }))) : null, [
        emoji,
        emojiProvider
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b599b35381503a14$export$c9c4bba9e22a634c), {
        ref: ref,
        id: id,
        color: color,
        isActive: isActive,
        isDeletePreviewed: isDeletePreviewed,
        isEditing: isEditing,
        orientation: orientation,
        showMenu: showMenu,
        tabIndex: tabIndex,
        onClick: (e)=>{
            isEditStartedWithKeyboardRef.current = false;
            handleClick(e);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                isEditStartedWithKeyboardRef.current = true;
                handleClick(e);
            }
        }
    }, emojiContent, isEditing && orientation === 'vertical' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $28754f1172ac39f2$var$styles.verticalTitleEditor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        "aria-hidden": "true",
        xcss: (0, $w6R6I.cx)($28754f1172ac39f2$var$styles.verticalTitle, $28754f1172ac39f2$var$styles.verticalTitleSizer)
    }, `${draftTitle} `), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "textarea",
        ref: inputRef,
        rows: 1,
        "aria-label": title,
        testId: `native-tabs-title-input-${id}`,
        value: draftTitle,
        onChange: handleDraftChange,
        onBlur: handleDraftBlur,
        onKeyDown: handleDraftKeyDown,
        xcss: (0, $w6R6I.cx)($28754f1172ac39f2$var$styles.titleInput, $28754f1172ac39f2$var$styles.verticalTitleTextarea)
    })), isEditing && orientation !== 'vertical' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "input",
        ref: inputRef,
        "aria-label": title,
        testId: `native-tabs-title-input-${id}`,
        value: draftTitle,
        onChange: handleDraftChange,
        onBlur: handleDraftBlur,
        onKeyDown: handleDraftKeyDown,
        xcss: $28754f1172ac39f2$var$styles.titleInput
    }), !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)(canRename && $28754f1172ac39f2$var$styles.editableTitle, orientation === 'vertical' && $28754f1172ac39f2$var$styles.verticalTitle)
    }, title));
});
$28754f1172ac39f2$export$78d1357ca0402517.displayName = 'TabPill';


/* TabPillMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $fS8Zl = parcelRequire("fS8Zl");


var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");


var $f6cdQ = parcelRequire("f6cdQ");


var $bAlk9 = parcelRequire("bAlk9");


var $iDfTs = parcelRequire("iDfTs");


var $b35Wv = parcelRequire("b35Wv");


var $kTb7m = parcelRequire("kTb7m");





var $4aRua = parcelRequire("4aRua");


var $ldqjS = parcelRequire("ldqjS");

/* TabColorMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 





















var $b391T = parcelRequire("b391T");





var $1l0kj = parcelRequire("1l0kj");




/* TabColorPicker.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $eh6Ml = parcelRequire("eh6Ml");














var $c0A7H = parcelRequire("c0A7H");


var $lpNn5 = parcelRequire("lpNn5");




const $23090c80bc28a47f$var$i18n = (0, $kSwu1.defineMessages)({
    noColor: {
        id: "native-tabs.tab-color-picker.no-color.non-final",
        defaultMessage: "No color"
    },
    selectedSuffix: {
        id: "native-tabs.tab-color-picker.selected-suffix.non-final",
        defaultMessage: "{colorLabel} (selected)"
    },
    colorPickerLabel: {
        id: "native-tabs.tab-color-picker.label.non-final",
        defaultMessage: "Tab color"
    },
    applyToAll: {
        id: "native-tabs.tab-color-picker.apply-to-all.non-final",
        defaultMessage: "Apply color to all tabs"
    }
});
const $23090c80bc28a47f$var$styles = {
    grid: "_2mHwu8gVvo _4c065U2ADO _2Y7lL48HPE _3iDTPbgBM8 _2iEGP2XIcE",
    swatch: "_0bjKvDKxmn _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0wOv4Q7zJH _3YEZNOdnbC",
    swatchNoColor: "_0KLXrulfZc",
    swatchFromCatalog: "_0KLXruj1Yy",
    actionsDivider: "_4c065UFQfX _0LQT5E8HPE _03SyCP2ADO"
};
const $23090c80bc28a47f$var$Swatch = ({ colorKey: colorKey, backgroundColor: backgroundColor, isSelected: isSelected, label: label, showTooltip: showTooltip, onColorSelect: onColorSelect, tabIndex: tabIndex, flatIndex: flatIndex, onFocusSwatch: onFocusSwatch, initialFocusRef: initialFocusRef })=>{
    const handleFocus = (0, $cozmU.useCallback)(()=>onFocusSwatch(flatIndex), [
        flatIndex,
        onFocusSwatch
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onColorSelect(colorKey);
    }, [
        colorKey,
        onColorSelect
    ]); // Capture initial values in refs so the ref callback below doesn't need
    // them as dependencies — the callback must only run on mount so that
    // React re-renders don't override the DOM tabIndex set by updateTabIndex.
    const initialTabIndexRef = (0, $cozmU.useRef)(tabIndex);
    const initialFocusRefRef = (0, $cozmU.useRef)(initialFocusRef); // Set tabIndex imperatively on mount so React re-renders don't override
    // the DOM changes made by updateTabIndex during keyboard navigation.
    const setRef = (0, $cozmU.useCallback)((el)=>{
        if (el) el.tabIndex = initialTabIndexRef.current;
        const focusRef = initialFocusRefRef.current;
        if (focusRef) {
            if (typeof focusRef === 'function') focusRef(el);
            else focusRef.current = el;
        }
    }, []);
    const swatch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ref: setRef,
        onClick: handleClick,
        onFocus: handleFocus,
        "aria-label": label,
        role: "radio",
        "aria-checked": isSelected ? 'true' : 'false',
        style: {
            '--tab-color-swatch-background-color': backgroundColor
        },
        xcss: (0, $w6R6I.cx)($23090c80bc28a47f$var$styles.swatch, backgroundColor ? $23090c80bc28a47f$var$styles.swatchFromCatalog : $23090c80bc28a47f$var$styles.swatchNoColor)
    }, isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon, #292A2E)"
    }));
    return showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: label
    }, swatch) : swatch;
};
$23090c80bc28a47f$var$Swatch.displayName = 'Swatch'; /**
                                * Helper function to get the localized swatch label.
                                * Handles the no-color case and appends the selected state when needed.
                                */ 
function $23090c80bc28a47f$var$getSwatchLabel(colorKey, isSelected, formatMessage, labelMessage) {
    if (colorKey === null) return formatMessage($23090c80bc28a47f$var$i18n.noColor);
    const label = labelMessage ? formatMessage(labelMessage) : colorKey;
    if (isSelected) return formatMessage($23090c80bc28a47f$var$i18n.selectedSuffix, {
        colorLabel: label
    });
    return label;
}
const $23090c80bc28a47f$export$5020cb47f22bfb6a = ({ currentColor: currentColor, onColorSelect: onColorSelect, setInitialFocusRef: setInitialFocusRef, palette: palette, applyToAll: applyToAll, onApplyToAllChange: onApplyToAllChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { appearanceMode: appearanceMode, columnCount: columnCount, showSwatchTooltips: showSwatchTooltips, swatches: colorSwatches } = palette;
    const totalItems = colorSwatches.length;
    const initialFocusIndex = currentColor !== undefined ? colorSwatches.indexOf(currentColor) : 0;
    const initialFocused = initialFocusIndex >= 0 ? initialFocusIndex : 0;
    const focusedIndexRef = (0, $cozmU.useRef)(initialFocused); // Update tabIndex directly on DOM elements to avoid re-rendering all swatches
    const updateTabIndex = (0, $cozmU.useCallback)((prevIndex, nextIndex)=>{
        const swatches = containerRef.current?.querySelectorAll('[role="radio"]');
        if (swatches) {
            swatches[prevIndex]?.setAttribute('tabindex', '-1');
            swatches[nextIndex]?.setAttribute('tabindex', '0');
        }
        focusedIndexRef.current = nextIndex;
    }, []);
    const handleFocusSwatch = (0, $cozmU.useCallback)((index)=>{
        updateTabIndex(focusedIndexRef.current, index);
    }, [
        updateTabIndex
    ]);
    const containerRef = (0, $cozmU.useRef)(null); // Keep keyboard navigation math over the flat swatch list.
    const handleGridKeyDown = (0, $cozmU.useCallback)((e)=>{
        let newIndex;
        switch(e.key){
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                newIndex = (focusedIndexRef.current + 1) % totalItems;
                break;
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                newIndex = (focusedIndexRef.current - 1 + totalItems) % totalItems;
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                newIndex = (focusedIndexRef.current + columnCount) % totalItems;
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                newIndex = (focusedIndexRef.current - columnCount + totalItems) % totalItems;
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                newIndex = 0;
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                newIndex = totalItems - 1;
                break;
            default:
                return;
        }
        updateTabIndex(focusedIndexRef.current, newIndex); // Focus the corresponding swatch element — scoped to this picker's container
        const swatchElements = containerRef.current?.querySelectorAll('[role="radio"]');
        swatchElements?.[newIndex]?.focus();
    }, [
        columnCount,
        totalItems,
        updateTabIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: containerRef,
        role: "radiogroup",
        "aria-label": formatMessage($23090c80bc28a47f$var$i18n.colorPickerLabel),
        onKeyDown: handleGridKeyDown,
        style: {
            '--tab-color-picker-column-count': columnCount
        },
        xcss: $23090c80bc28a47f$var$styles.grid
    }, colorSwatches.map((colorKey, flatIndex)=>{
        const isSelected = colorKey === currentColor || colorKey === null && currentColor === undefined;
        const appearance = colorKey ? (0, $ipqo7.getTabColorAppearance)(colorKey, appearanceMode) : undefined;
        const label = $23090c80bc28a47f$var$getSwatchLabel(colorKey, isSelected, formatMessage, appearance?.swatch.labelMessage);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23090c80bc28a47f$var$Swatch, {
            key: `${flatIndex}-${colorKey ?? 'none'}`,
            colorKey: colorKey,
            backgroundColor: appearance?.swatch.backgroundColor,
            isSelected: isSelected,
            label: label,
            showTooltip: showSwatchTooltips,
            onColorSelect: onColorSelect,
            tabIndex: flatIndex === initialFocused ? 0 : -1,
            flatIndex: flatIndex,
            onFocusSwatch: handleFocusSwatch,
            initialFocusRef: flatIndex === initialFocused ? setInitialFocusRef : undefined
        });
    })), onApplyToAllChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        spread: "space-between",
        xcss: $23090c80bc28a47f$var$styles.actionsDivider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, formatMessage($23090c80bc28a47f$var$i18n.applyToAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
        label: formatMessage($23090c80bc28a47f$var$i18n.applyToAll),
        isChecked: applyToAll,
        onChange: (e)=>{
            e.stopPropagation();
            onApplyToAllChange(e.currentTarget.checked);
        }
    })));
};
$23090c80bc28a47f$export$5020cb47f22bfb6a.displayName = 'TabColorPicker';








const $f73edce490126d62$export$ab5a8b11862e7e52 = [
    null,
    'blue-subtlest',
    'teal-subtlest',
    'green-subtlest',
    'yellow-subtlest',
    'red-subtlest',
    'purple-subtlest',
    'gray-subtler',
    'blue-subtler',
    'teal-subtler',
    'green-subtler',
    'yellow-subtler',
    'red-subtler',
    'purple-subtler',
    'gray-subtle',
    'blue-subtle',
    'teal-subtle',
    'green-subtle',
    'orange-subtle',
    'red-subtle',
    'purple-subtle'
];
const $f73edce490126d62$export$b81aa637a677f1f2 = [
    null,
    'blue-subtlest',
    'teal-subtlest',
    'green-subtlest',
    'lime-subtlest',
    'yellow-subtlest',
    'orange-subtlest',
    'red-subtlest',
    'magenta-subtlest',
    'purple-subtlest',
    'gray-subtler',
    'blue-subtler',
    'teal-subtler',
    'green-subtler',
    'lime-subtler',
    'yellow-subtler',
    'orange-subtler',
    'red-subtler',
    'magenta-subtler',
    'purple-subtler',
    'gray-subtle',
    'blue-subtle',
    'teal-subtle',
    'green-subtle',
    'lime-subtle',
    'yellow-subtle',
    'orange-subtle',
    'red-subtle',
    'magenta-subtle',
    'purple-subtle'
];
const $f73edce490126d62$export$78ca53354a87dae5 = {
    swatches: $f73edce490126d62$export$ab5a8b11862e7e52,
    columnCount: 7,
    appearanceMode: 'legacy',
    showSwatchTooltips: false
};
const $f73edce490126d62$export$5a3d8d5735abcf44 = {
    swatches: $f73edce490126d62$export$b81aa637a677f1f2,
    columnCount: 10,
    appearanceMode: 'standard',
    showSwatchTooltips: true
};
const $f73edce490126d62$export$77f4e9710dd4b027 = (useStandardColorPalette)=>useStandardColorPalette ? $f73edce490126d62$export$5a3d8d5735abcf44 : $f73edce490126d62$export$78ca53354a87dae5;


const $3fcc69ab9ec84663$var$i18n = (0, $kSwu1.defineMessages)({
    tabColor: {
        id: "native-tabs.tab-pill-menu.tab-color.non-final",
        defaultMessage: "Tab color"
    }
});
const $3fcc69ab9ec84663$var$styles = {
    colorPreviewSwatch: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC",
    colorPreviewSwatchNoColor: "_0KLXrulfZc",
    colorPreviewSwatchFromCatalog: "_0KLXruSW6p"
};
const $3fcc69ab9ec84663$export$231e7c364d6fd9ad = ({ applyToAll: applyToAll, currentColor: currentColor, isParentMenuOpen: isParentMenuOpen, onApplyToAllChange: onApplyToAllChange, onColorChange: onColorChange })=>{
    const [isColorMenuOpen, setIsColorMenuOpen] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const palette = (0, $f73edce490126d62$export$77f4e9710dd4b027)((0, $ihDzO.isStandardTabColorPaletteEnabled)());
    const currentColorAppearance = currentColor ? (0, $ipqo7.getTabColorAppearance)(currentColor, palette.appearanceMode) : undefined;
    (0, $cozmU.useEffect)(()=>{
        if (!isParentMenuOpen) setIsColorMenuOpen(false);
    }, [
        isParentMenuOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        isOpen: isColorMenuOpen,
        onOpenChange: ({ isOpen: isOpen })=>{
            setIsColorMenuOpen(isOpen);
        },
        placement: "right-start",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                ...triggerProps,
                ref: triggerRef,
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b391T))), {
                    label: formatMessage($3fcc69ab9ec84663$var$i18n.tabColor),
                    size: "small"
                }),
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.075"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    testId: "native-tabs-color-swatch-preview",
                    style: {
                        '--tab-color-preview-background-color': currentColorAppearance?.swatch.backgroundColor
                    },
                    xcss: (0, $w6R6I.cx)($3fcc69ab9ec84663$var$styles.colorPreviewSwatch, currentColorAppearance ? $3fcc69ab9ec84663$var$styles.colorPreviewSwatchFromCatalog : $3fcc69ab9ec84663$var$styles.colorPreviewSwatchNoColor)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "currentColor"
                }))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtle"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3fcc69ab9ec84663$var$i18n.tabColor)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $23090c80bc28a47f$export$5020cb47f22bfb6a), {
        currentColor: currentColor,
        onColorSelect: (colorKey)=>{
            onColorChange?.(colorKey ?? undefined);
        },
        palette: palette,
        applyToAll: applyToAll,
        onApplyToAllChange: (isChecked)=>{
            onApplyToAllChange?.(isChecked);
            if (isChecked) onColorChange?.(currentColor);
        }
    })));
};
$3fcc69ab9ec84663$export$231e7c364d6fd9ad.displayName = 'TabColorMenuItem';


/* TabColorMenuTrigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $6TaGl = parcelRequire("6TaGl");










const $91762d2728cb9aa7$var$styles = {
    trigger: "_0bjKvDdnbC _23rrnHoacQ _4c065U1Y8M _3hxITi6wH8 _2V7sgOvc3e _3vBAKHrzt2 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _4xdlr0FlnN _0LQT5E1Y8M _03SyCP2ADO _0mcu6jS5Zs _3kIZMxS5Zs _17eyLEdnbC _0KLXruY9q9 _1UtDYzjTy9",
    triggerVertical: "_0mcu6juMRm _3kIZMxuMRm",
    triggerDeletePreview: "_3vBAKHnod9 _1UtDYzAyGJ _0KLXruhH7k",
    triggerFromCatalog: "_3vBAKHSgof _0KLXrueM5t _1UtDYzLALu"
};
const $91762d2728cb9aa7$export$458f26d11609ca53 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ currentColor: currentColor, isDeletePreviewed: isDeletePreviewed = false, label: label, orientation: orientation = 'horizontal', ...triggerProps }, ref)=>{
    const appearanceMode = (0, $ihDzO.isStandardTabColorPaletteEnabled)() ? 'standard' : 'legacy';
    const activeTabPillColor = currentColor ? (0, $ipqo7.getTabColorAppearance)(currentColor, appearanceMode).tabPill.active : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...triggerProps,
        ref: ref,
        "aria-label": label,
        style: {
            '--tab-color-menu-trigger-background-color': activeTabPillColor?.backgroundColor,
            '--tab-color-menu-trigger-border-color': activeTabPillColor?.borderColor,
            '--tab-color-menu-trigger-text-color': activeTabPillColor?.textColor
        },
        xcss: (0, $w6R6I.cx)($91762d2728cb9aa7$var$styles.trigger, orientation === 'vertical' && $91762d2728cb9aa7$var$styles.triggerVertical, !isDeletePreviewed && activeTabPillColor && $91762d2728cb9aa7$var$styles.triggerFromCatalog, isDeletePreviewed && $91762d2728cb9aa7$var$styles.triggerDeletePreview),
        onMouseDown: (event)=>event.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "",
        color: "currentColor"
    }));
});
$91762d2728cb9aa7$export$458f26d11609ca53.displayName = 'TabColorMenuTrigger';


const $c9462c03ee5abe45$var$moveTabLeftKeymap = (0, $ldqjS.makeKeymap)('Move tab left', 'Ctrl-Alt-ArrowLeft', 'Cmd-Ctrl-Alt-ArrowLeft');
const $c9462c03ee5abe45$var$moveTabRightKeymap = (0, $ldqjS.makeKeymap)('Move tab right', 'Ctrl-Alt-ArrowRight', 'Cmd-Ctrl-Alt-ArrowRight');
const $c9462c03ee5abe45$var$moveTabLeftShortcut = (0, $ldqjS.tooltip)($c9462c03ee5abe45$var$moveTabLeftKeymap);
const $c9462c03ee5abe45$var$moveTabRightShortcut = (0, $ldqjS.tooltip)($c9462c03ee5abe45$var$moveTabRightKeymap);
const $c9462c03ee5abe45$var$moveTabUpShortcut = (0, $ldqjS.tooltip)((0, $ldqjS.makeKeymap)('Move tab up', 'Ctrl-Alt-ArrowUp', 'Cmd-Ctrl-Alt-ArrowUp'));
const $c9462c03ee5abe45$var$moveTabDownShortcut = (0, $ldqjS.tooltip)((0, $ldqjS.makeKeymap)('Move tab down', 'Ctrl-Alt-ArrowDown', 'Cmd-Ctrl-Alt-ArrowDown'));
const $c9462c03ee5abe45$var$styles = {
    shortcut: "_0bjKvDKxmn _2sNsIg7NXe _4c065U1Y8M _2Y7lL41Y8M _0KLXruDMqu _1UtDYzZpcK _4xdlr0z9WS"
};
const $c9462c03ee5abe45$var$i18n = (0, $kSwu1.defineMessages)({
    tabOptions: {
        id: "native-tabs.tab-pill-menu.tab-options.non-final",
        defaultMessage: "Tab options"
    },
    addEmoji: {
        id: "native-tabs.tab-pill-menu.add-emoji.non-final",
        defaultMessage: "Add emoji"
    },
    removeEmoji: {
        id: "native-tabs.tab-pill-menu.remove-emoji.non-final",
        defaultMessage: "Remove emoji"
    },
    copyLink: {
        id: "native-tabs.tab-pill-menu.copy-link.non-final",
        defaultMessage: "Copy link to tab"
    },
    deleteTab: {
        id: "native-tabs.tab-pill-menu.delete-tab.non-final",
        defaultMessage: "Delete"
    },
    moveTabLeft: {
        id: "native-tabs.tab-pill-menu.move-tab-left.non-final",
        defaultMessage: "Move tab left"
    },
    moveTabRight: {
        id: "native-tabs.tab-pill-menu.move-tab-right.non-final",
        defaultMessage: "Move tab right"
    },
    moveTabUp: {
        id: "native-tabs.tab-pill-menu.move-tab-up.non-final",
        defaultMessage: "Move tab up"
    },
    moveTabDown: {
        id: "native-tabs.tab-pill-menu.move-tab-down.non-final",
        defaultMessage: "Move tab down"
    }
});
const $c9462c03ee5abe45$export$eb6be6bd9c8f6ee4 = ({ hasEmoji: hasEmoji, onEmojiPickerOpen: onEmojiPickerOpen, onRemoveEmoji: onRemoveEmoji, isEmojiPickerOpen: isEmojiPickerOpen, onEmojiPickerClose: onEmojiPickerClose, emojiPickerContent: emojiPickerContent, onMoveTabPrevious: onMoveTabPrevious, onMoveTabNext: onMoveTabNext, onCopyLink: onCopyLink, onDeleteTab: onDeleteTab, isDeleteDisabled: isDeleteDisabled, onDeletePreviewStart: onDeletePreviewStart, onDeletePreviewEnd: onDeletePreviewEnd, isDeletePreviewed: isDeletePreviewed = false, isFirst: isFirst, isLast: isLast, currentColor: currentColor, onColorChange: onColorChange, applyToAll: applyToAll, onApplyToAllChange: onApplyToAllChange, scrollContainerRef: scrollContainerRef, orientation: orientation = 'horizontal' })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $cozmU.useState)(false);
    const closeMenu = (0, $cozmU.useCallback)(()=>{
        setIsMenuOpen(false);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const el = scrollContainerRef?.current;
        if (!el) return;
        el.addEventListener('scroll', closeMenu, {
            passive: true
        });
        return ()=>el.removeEventListener('scroll', closeMenu);
    }, [
        closeMenu,
        scrollContainerRef
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tabOptionsLabel = formatMessage($c9462c03ee5abe45$var$i18n.tabOptions);
    const handleDeletePreviewStart = (0, $cozmU.useCallback)(()=>{
        if (!isDeleteDisabled) onDeletePreviewStart?.();
    }, [
        isDeleteDisabled,
        onDeletePreviewStart
    ]);
    const handleDeletePreviewEnd = (0, $cozmU.useCallback)(()=>{
        onDeletePreviewEnd?.();
    }, [
        onDeletePreviewEnd
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        isOpen: isMenuOpen || isEmojiPickerOpen,
        placement: orientation === 'vertical' ? 'left-start' : 'bottom-end',
        spacing: "compact",
        onOpenChange: ({ isOpen: isOpen })=>{
            if (!isOpen) {
                if (isEmojiPickerOpen) onEmojiPickerClose?.();
                setIsMenuOpen(false);
                handleDeletePreviewEnd();
            } else if (!isEmojiPickerOpen) setIsMenuOpen(true);
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91762d2728cb9aa7$export$458f26d11609ca53), {
                ...triggerProps,
                ref: (el)=>{
                    if (typeof triggerRef === 'function') triggerRef(el);
                    else if (triggerRef) triggerRef.current = el;
                },
                label: tabOptionsLabel,
                currentColor: currentColor,
                isDeletePreviewed: isDeletePreviewed,
                orientation: orientation
            })
    }, isEmojiPickerOpen ? emojiPickerContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3fcc69ab9ec84663$export$231e7c364d6fd9ad), {
        currentColor: currentColor,
        onColorChange: onColorChange,
        applyToAll: applyToAll,
        onApplyToAllChange: onApplyToAllChange,
        isParentMenuOpen: isMenuOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        hasSeparator: true
    }, hasEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAlk9))), {
            label: formatMessage($c9462c03ee5abe45$var$i18n.removeEmoji),
            size: "small"
        }),
        onClick: onRemoveEmoji
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c9462c03ee5abe45$var$i18n.removeEmoji))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            label: formatMessage($c9462c03ee5abe45$var$i18n.addEmoji),
            size: "small"
        }),
        onClick: onEmojiPickerOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c9462c03ee5abe45$var$i18n.addEmoji))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: formatMessage($c9462c03ee5abe45$var$i18n.copyLink),
            size: "small"
        }),
        onClick: ()=>{
            closeMenu();
            onCopyLink?.();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c9462c03ee5abe45$var$i18n.copyLink)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: orientation === 'vertical' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
            label: "",
            color: "currentColor",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
            label: "",
            color: "currentColor",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c9462c03ee5abe45$var$styles.shortcut
        }, orientation === 'vertical' ? $c9462c03ee5abe45$var$moveTabUpShortcut : $c9462c03ee5abe45$var$moveTabLeftShortcut),
        onClick: onMoveTabPrevious,
        isDisabled: isFirst
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), orientation === 'vertical' ? $c9462c03ee5abe45$var$i18n.moveTabUp : $c9462c03ee5abe45$var$i18n.moveTabLeft))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: orientation === 'vertical' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
            label: "",
            color: "currentColor",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            label: "",
            color: "currentColor",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c9462c03ee5abe45$var$styles.shortcut
        }, orientation === 'vertical' ? $c9462c03ee5abe45$var$moveTabDownShortcut : $c9462c03ee5abe45$var$moveTabRightShortcut),
        onClick: onMoveTabNext,
        isDisabled: isLast
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), orientation === 'vertical' ? $c9462c03ee5abe45$var$i18n.moveTabDown : $c9462c03ee5abe45$var$i18n.moveTabRight)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "presentation",
        onMouseEnter: handleDeletePreviewStart,
        onMouseLeave: handleDeletePreviewEnd,
        onFocus: handleDeletePreviewStart,
        onBlur: handleDeletePreviewEnd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            label: formatMessage($c9462c03ee5abe45$var$i18n.deleteTab),
            color: isDeleteDisabled ? "var(--ds-text-disabled, #080F214A)" : "var(--ds-text-danger, #AE2E24)",
            size: "small"
        }),
        onClick: ()=>{
            handleDeletePreviewEnd();
            onDeleteTab?.();
        },
        isDisabled: isDeleteDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: isDeleteDisabled ? 'color.text.disabled' : 'color.text.danger'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c9462c03ee5abe45$var$i18n.deleteTab)))))));
};
$c9462c03ee5abe45$export$eb6be6bd9c8f6ee4.displayName = 'TabPillMenu';


const $5644460bd08617e5$var$styles = {
    srOnly: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _4bt5LAnQyn _2WAcuGnQyn _2V7sgOdnbC _1mT5xdWVPG _39xV02HZdu _0jFU0VHZdu _1ANEUSLRg7",
    menuTriggerFused: "_3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN",
    overflowVisible: "_4bt5LAYvD1 _2WAcuGYvD1",
    scrollContainer: "_4bt5LAIZbP _2WAcuGYvD1 _3oUqlsYbGa _3iDTPbQ4SZ _46hvQm2ADO _0xmtko1Y8M _0LQT5E1Y8M _03SyCP1Y8M",
    tabBarRow: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0hPCNLDIqT _0aFT5v1qpb _39xV02N91d _17lj8p2ADO",
    tabBarColumn: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0hPCNLFlnN _0aFT5vbt8w _3YEZNOdnbC _39xV02E6Kk _1EqgXlAef5",
    scrollContainerVertical: "_3iDTPbQ4SZ _0aFT5vbt8w _0NUa3rMLpr _4bt5LAYvD1 _2WAcuGIZbP",
    scrollContainerWrapperVertical: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC",
    tabPillItemVertical: "_4bt5LAYvD1 _2WAcuGYvD1 _3YEZNOdnbC _1mT5xdRAKS",
    tabItems: "_3iDTPbQ4SZ _0hPCNLDIqT _17lj8p2ADO _0aFT5v1qpb _3TGfC9LRg7",
    tabItemsVertical: "_0hPCNLchRC _42d1HA2ADO _17lj8pPgdg _0aFT5vbt8w",
    addTabButton: "_43nrzTFQfX",
    addTabButtonVertical: "_4xdlr0z9WS",
    tabPillItem: "_4bt5LAYvD1 _2WAcuGYvD1 _3YEZNOdnbC _1mT5xdRAKS",
    tabPillWrapper: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLFlnN",
    terminalDropPlaceholder: "_3iDTPbQ4SZ _0hPCNLFlnN _3YEZNOdnbC _39xV02Jg58",
    terminalDropIndicatorAnchor: "_1mT5xdRAKS _3YEZNOdnbC _39xV02dnbC _0GTcwR1Y8M",
    dragBar: "_0bjKvDKxmn _23rrnHDwP8 _4bt5LAnQyn _2WAcuGnQyn _30huDKYbGa _4FKVYEPgdg _1mT5xdWVPG _2IhTonPgdg _3OE6xY715P _1VJPcaiDnZ _0wOv4QAxrc _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1UtDYzjTy9 _39xV02oWWg _0jFU0VUNDJ _0KLXrueZ10 _1YKVNsdnbC",
    navButton: "_43nrzTFQfX",
    verticalNavGroup: "_3iDTPbQ4SZ _4xdlr0z9WS _0aFT5vbt8w _42d1HA1Y8M _43nrzTFQfX",
    menuTriggerFusedColored: "_3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN",
    scrollContainerWrapper: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _3iDTPbQ4SZ _4ouGXIdnbC _0GTcwR5UaJ _2xTnZx5UaJ",
    scrollFadeLeft: "_1mT5xdWVPG _3OE6xYdnbC _2IhTondnbC _0Bm75GdnbC _39xV02oWWg _3CkH9o8oDZ _1pp6NdYbGa _42Yu6B7dHp",
    scrollFadeRight: "_1mT5xdWVPG _4ApkO2dnbC _2IhTondnbC _0Bm75GdnbC _39xV02oWWg _3CkH9oe6gH _1pp6NdYbGa _42Yu6B7dHp",
    scrollFadeTop: "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _4ApkO2dnbC _0jFU0VoWWg _3CkH9olKLI _1pp6NdYbGa _42Yu6B7dHp",
    scrollFadeBottom: "_1mT5xdWVPG _0Bm75GdnbC _3OE6xYdnbC _4ApkO2dnbC _0jFU0VoWWg _3CkH9o565s _1pp6NdYbGa _42Yu6B7dHp"
};
const $5644460bd08617e5$var$idle = {
    type: 'idle'
};
const $5644460bd08617e5$var$i18n = (0, $kSwu1.defineMessages)({
    tablistLabel: {
        id: "native-tabs.tab-bar.tablist-label.non-final",
        defaultMessage: "Tabs"
    },
    addTab: {
        id: "native-tabs.tab-bar.add-tab-label.non-final",
        defaultMessage: "Add tab"
    },
    scrollTabsLeft: {
        id: "native-tabs.tab-bar.scroll-tabs-left.non-final",
        defaultMessage: "Scroll tabs left"
    },
    scrollTabsRight: {
        id: "native-tabs.tab-bar.scroll-tabs-right.non-final",
        defaultMessage: "Scroll tabs right"
    },
    scrollTabsUp: {
        id: "native-tabs.tab-bar.scroll-tabs-up.non-final",
        defaultMessage: "Scroll tabs up"
    },
    scrollTabsDown: {
        id: "native-tabs.tab-bar.scroll-tabs-down.non-final",
        defaultMessage: "Scroll tabs down"
    }
});
const $5644460bd08617e5$var$TabBarItem = ({ tab: tab, index: index, isActive: isActive, showMenuButton: showMenuButton, canDrag: canDrag, orientation: orientation, registerRef: registerRef, registerMenuRef: registerMenuRef, onSelect: onSelect, onEmojiPickerOpen: onEmojiPickerOpen, onRemoveEmoji: onRemoveEmoji, isEmojiPickerOpen: isEmojiPickerOpen = false, onEmojiPickerClose: onEmojiPickerClose, emojiPickerContent: emojiPickerContent = null, emojiProvider: emojiProvider, onMoveTabPrevious: onMoveTabPrevious, onMoveTabNext: onMoveTabNext, onCopyLink: onCopyLink, onDeleteTab: onDeleteTab, canRename: canRename, editingTabId: editingTabId, onTitleEditStart: onTitleEditStart, onTitleEditSave: onTitleEditSave, onTitleEditCancel: onTitleEditCancel, isFirst: isFirst, isLast: isLast, isDeletePreviewed: isDeletePreviewed, onDeletePreviewStart: onDeletePreviewStart, onDeletePreviewEnd: onDeletePreviewEnd, scrollContainerRef: scrollContainerRef, externalInstanceId: externalInstanceId, registerPillWrapper: registerPillWrapper, onColorChange: onColorChange, applyToAll: applyToAll, onApplyToAllChange: onApplyToAllChange, contentAreaEdge: contentAreaEdge })=>{
    const axis = (0, $k6Q5P.getTabAxis)(orientation);
    const [dragState, setDragState] = (0, $cozmU.useState)($5644460bd08617e5$var$idle);
    const [pillEdge, setPillEdge] = (0, $cozmU.useState)(null);
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const dragBarRef = (0, $cozmU.useRef)(null);
    const [isBarHovered, setIsBarHovered] = (0, $cozmU.useState)(false);
    const [optimisticColor, setOptimisticColor] = (0, $cozmU.useState)(tab.color); // Merge pill-level edge (cursor over this pill) with content-area edge (cursor below header).
    // Pill-level takes priority when set.
    const closestEdge = pillEdge ?? contentAreaEdge ?? null; // Sync optimisticColor when tab.color is updated externally (e.g. applyToAll from another tab).
    (0, $cozmU.useEffect)(()=>{
        setOptimisticColor(tab.color);
    }, [
        tab.color
    ]);
    const wrapperRef = (0, $cozmU.useRef)(null); // Register this pill's wrapper element for expanded drop detection.
    (0, $cozmU.useEffect)(()=>{
        registerPillWrapper?.(index, wrapperRef.current);
        return ()=>registerPillWrapper?.(index, null);
    }, [
        index,
        registerPillWrapper
    ]);
    const handleRef = (element)=>{
        registerRef(index, element);
    };
    const handleMenuRef = (element)=>{
        registerMenuRef(index, element);
    };
    const handleClick = ()=>{
        onSelect(index);
    }; // Restrict effectAllowed to 'move' to prevent the browser from showing a
    // green "+" (copy) cursor inside contenteditable areas.
    const handleDragStart = (0, $cozmU.useCallback)((e)=>{
        e.dataTransfer.effectAllowed = 'move';
    }, []);
    const { startEdge: startEdge, endEdge: endEdge } = axis; // Horizontal terminal placeholders create room between side-by-side pills. Vertical
    // indicators can render at the top/bottom edge without consuming pill width.
    const shouldShowFirstDropPlaceholder = orientation === 'horizontal' && isFirst && closestEdge === startEdge;
    const shouldShowLastDropPlaceholder = orientation === 'horizontal' && isLast && closestEdge === endEdge;
    (0, $cozmU.useEffect)(()=>{
        if (!dragBarRef.current) return;
        dragBarRef.current.style.opacity = isHovered ? '1' : '0';
    }, [
        isHovered
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!canDrag) return;
        const dropTargetEl = wrapperRef.current;
        if (!dropTargetEl) return;
        const targetInstanceId = externalInstanceId ?? scrollContainerRef.current;
        return (0, $4QfFX.combine)((0, $4Vdlk.draggable)({
            element: dropTargetEl,
            getInitialData: ()=>({
                    type: (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e),
                    index: index,
                    instanceId: externalInstanceId ?? scrollContainerRef.current
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $deUyp.setCustomNativeDragPreview)({
                    getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'generate-preview',
                            container: container
                        });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                setDragState({
                    type: 'dragging'
                });
                if (wrapperRef.current) wrapperRef.current.style.opacity = "var(--ds-opacity-loading, 0.2)";
            },
            onDrop: ()=>{
                setDragState($5644460bd08617e5$var$idle);
                if (wrapperRef.current) wrapperRef.current.style.opacity = '';
            }
        }), (0, $4Vdlk.dropTargetForElements)({
            element: dropTargetEl,
            canDrop: ({ source: source })=>source.data.type === (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e) && source.data.index !== index && source.data.instanceId === targetInstanceId,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: dropEl })=>(0, $endUL.attachClosestEdge)({
                    type: (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e),
                    index: index,
                    instanceId: targetInstanceId
                }, {
                    input: input,
                    element: dropEl,
                    allowedEdges: [
                        axis.startEdge,
                        axis.endEdge
                    ]
                }),
            onDrag: ({ self: self })=>setPillEdge((0, $ez93V.extractClosestEdge)(self.data)),
            onDragLeave: ()=>setPillEdge(null),
            onDrop: ()=>setPillEdge(null)
        }));
    }, [
        index,
        canDrag,
        axis,
        scrollContainerRef,
        externalInstanceId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: wrapperRef,
        xcss: $5644460bd08617e5$var$styles.tabPillWrapper,
        testId: "native-tabs-tab-pill-wrapper",
        onDragStart: handleDragStart,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsHovered(true),
        onBlur: ()=>setIsHovered(false)
    }, shouldShowFirstDropPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        xcss: $5644460bd08617e5$var$styles.terminalDropPlaceholder,
        testId: `native-tabs-first-drop-placeholder-${tab.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.terminalDropIndicatorAnchor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
        edge: "left",
        gap: "var(--ds-space-0, 0px)"
    }))), canDrag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ref: dragBarRef,
        xcss: $5644460bd08617e5$var$styles.dragBar,
        "aria-hidden": "true",
        tabIndex: -1,
        onMouseEnter: ()=>{
            setIsBarHovered(true);
            if (dragBarRef.current) {
                dragBarRef.current.style.width = '32px';
                dragBarRef.current.style.height = '16px';
                dragBarRef.current.style.backgroundColor = isActive ? "var(--ds-background-selected-hovered, #CFE1FD)" : "var(--ds-background-selected, #E9F2FE)";
            }
        },
        onFocus: ()=>{
            setIsBarHovered(true);
            if (dragBarRef.current) {
                dragBarRef.current.style.width = '32px';
                dragBarRef.current.style.height = '16px';
                dragBarRef.current.style.backgroundColor = isActive ? "var(--ds-background-selected-hovered, #CFE1FD)" : "var(--ds-background-selected, #E9F2FE)";
            }
        },
        onMouseLeave: ()=>{
            setIsBarHovered(false);
            if (dragBarRef.current) {
                dragBarRef.current.style.width = '24px';
                dragBarRef.current.style.height = '4px';
                dragBarRef.current.style.backgroundColor = "var(--ds-background-accent-gray-subtle, #8C8F97)";
            }
        },
        onBlur: ()=>{
            setIsBarHovered(false);
            if (dragBarRef.current) {
                dragBarRef.current.style.width = '24px';
                dragBarRef.current.style.height = '4px';
                dragBarRef.current.style.backgroundColor = "var(--ds-background-accent-gray-subtle, #8C8F97)";
            }
        }
    }, isBarHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9EfQi))), {
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28754f1172ac39f2$export$78d1357ca0402517), {
        id: tab.id,
        title: tab.title,
        emoji: tab.emoji,
        emojiProvider: emojiProvider,
        isActive: isActive,
        tabIndex: isActive ? 0 : -1,
        ref: handleRef,
        onClick: handleClick,
        showMenu: showMenuButton,
        onEmojiClick: isActive && tab.emoji ? onEmojiPickerOpen : undefined,
        canRename: canRename,
        isEditing: editingTabId === tab.id,
        isDeletePreviewed: isDeletePreviewed,
        onTitleEditStart: ()=>onTitleEditStart(index),
        onTitleEditSave: (title, options)=>onTitleEditSave(index, title, options),
        onTitleEditCancel: (options)=>onTitleEditCancel(index, options),
        color: optimisticColor,
        orientation: orientation
    }), showMenuButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: handleMenuRef,
        xcss: (0, $w6R6I.cx)(optimisticColor ? $5644460bd08617e5$var$styles.menuTriggerFusedColored : $5644460bd08617e5$var$styles.menuTriggerFused)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9462c03ee5abe45$export$eb6be6bd9c8f6ee4), {
        scrollContainerRef: scrollContainerRef,
        hasEmoji: Boolean(tab.emoji),
        onEmojiPickerOpen: onEmojiPickerOpen,
        onRemoveEmoji: onRemoveEmoji,
        isEmojiPickerOpen: isEmojiPickerOpen,
        onEmojiPickerClose: onEmojiPickerClose,
        emojiPickerContent: emojiPickerContent,
        onMoveTabPrevious: onMoveTabPrevious,
        onMoveTabNext: onMoveTabNext,
        onCopyLink: onCopyLink,
        onDeleteTab: ()=>onDeleteTab?.(index),
        isDeleteDisabled: !onDeleteTab || isFirst && isLast,
        onDeletePreviewStart: ()=>onDeletePreviewStart(index),
        onDeletePreviewEnd: onDeletePreviewEnd,
        isDeletePreviewed: isDeletePreviewed,
        isFirst: isFirst,
        isLast: isLast,
        tabId: tab.id,
        onColorChange: (color)=>{
            setOptimisticColor(color);
            onColorChange?.(color);
        },
        currentColor: optimisticColor,
        applyToAll: applyToAll,
        onApplyToAllChange: onApplyToAllChange,
        orientation: orientation
    })), shouldShowLastDropPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        xcss: $5644460bd08617e5$var$styles.terminalDropPlaceholder,
        testId: `native-tabs-last-drop-placeholder-${tab.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.terminalDropIndicatorAnchor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
        edge: "left",
        gap: "var(--ds-space-0, 0px)"
    }))), closestEdge && !shouldShowFirstDropPlaceholder && !shouldShowLastDropPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
        edge: closestEdge,
        gap: "var(--ds-space-100, 8px)"
    })), dragState.type === 'generate-preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9bc14a5cc51e8486$export$d6c426749d4e8e80), {
        title: tab.title
    }), dragState.container) : null);
};
const $5644460bd08617e5$export$f97dc4a5a0177256 = ({ tabs: tabs, activeIndex: activeIndex, onTabClick: onTabClick, onAddTab: onAddTab, onRenameTab: onRenameTab, canEdit: canEdit, orientation: orientation = 'horizontal', onReorderTabs: onReorderTabs, onMoveTabPrevious: onMoveTabPrevious, onMoveTabNext: onMoveTabNext, onCopyLink: onCopyLink, onDeleteTab: onDeleteTab, onEmojiPickerOpen: onEmojiPickerOpen, onRemoveEmoji: onRemoveEmoji, isEmojiPickerOpen: isEmojiPickerOpen = false, onEmojiPickerClose: onEmojiPickerClose, emojiPickerContent: emojiPickerContent = null, emojiProvider: emojiProvider, onColorChange: onColorChange, applyToAll: applyToAll, onApplyToAllChange: onApplyToAllChange, contentAreaDrop: contentAreaDrop, instanceId: instanceId, registerPillWrapper: registerPillWrapper })=>{
    const axis = (0, $k6Q5P.getTabAxis)(orientation);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tabRefs = (0, $cozmU.useRef)([]);
    const tabMenuRefs = (0, $cozmU.useRef)([]);
    const scrollContainerRef = (0, $cozmU.useRef)(null);
    const canDrag = canEdit && tabs.length > 1;
    const [editingTabId, setEditingTabId] = (0, $cozmU.useState)(null);
    const [deletePreviewIndex, setDeletePreviewIndex] = (0, $cozmU.useState)(null); // Deleting is applied by the parent editor hook, so focus must wait for the updated tabs.
    const pendingDeleteFocusRef = (0, $cozmU.useRef)(null);
    const registerRef = (0, $cozmU.useCallback)((index, element)=>{
        tabRefs.current[index] = element;
    }, []);
    const registerMenuRef = (0, $cozmU.useCallback)((index, element)=>{
        tabMenuRefs.current[index] = element;
    }, []);
    const focusTab = (0, $cozmU.useCallback)((nextIndex, currentIndex)=>{
        if (nextIndex === currentIndex) return;
        onTabClick(nextIndex);
        tabRefs.current[nextIndex]?.focus();
    }, [
        onTabClick
    ]);
    const restoreTabFocus = (0, $cozmU.useCallback)((index, focusVisible = true)=>{
        setTimeout(()=>{
            // focusVisible: false keeps focus on the tab without a focus ring after a mouse-started
            // rename. Browsers that don't support the option fall back to their default behaviour.
            tabRefs.current[index]?.focus({
                focusVisible: focusVisible
            });
        }, 0);
    }, []);
    const captureScrollOffset = (0, $cozmU.useCallback)(()=>scrollContainerRef.current?.[axis.scrollPos], [
        axis
    ]);
    const restoreScrollOffset = (0, $cozmU.useCallback)((scrollOffset)=>{
        if (scrollOffset === undefined) return;
        const restore = ()=>{
            const el = scrollContainerRef.current;
            if (el) el[axis.scrollPos] = scrollOffset;
        };
        if (typeof requestAnimationFrame !== 'function') {
            restore();
            return;
        }
        requestAnimationFrame(restore);
    }, [
        axis
    ]);
    const handleTitleEditStart = (0, $cozmU.useCallback)((index)=>{
        const tab = tabs[index];
        if (!canEdit || !tab || index !== activeIndex) return;
        setEditingTabId(tab.id);
    }, [
        activeIndex,
        canEdit,
        tabs
    ]);
    const handleTitleEditSave = (0, $cozmU.useCallback)((index, title, { shouldRestoreFocus: shouldRestoreFocus = false, focusVisible: focusVisible = true } = {})=>{
        const trimmedTitle = title.trim();
        const scrollOffset = captureScrollOffset();
        if (trimmedTitle && canEdit && onRenameTab && trimmedTitle !== tabs[index]?.title) onRenameTab(index, trimmedTitle);
        setEditingTabId(null);
        if (shouldRestoreFocus) restoreTabFocus(index, focusVisible);
        restoreScrollOffset(scrollOffset);
    }, [
        canEdit,
        captureScrollOffset,
        onRenameTab,
        restoreScrollOffset,
        restoreTabFocus,
        tabs
    ]);
    const handleTitleEditCancel = (0, $cozmU.useCallback)((index, { focusVisible: focusVisible = true } = {})=>{
        setEditingTabId(null);
        restoreTabFocus(index, focusVisible);
    }, [
        restoreTabFocus
    ]);
    const handleDeletePreviewStart = (0, $cozmU.useCallback)((index)=>{
        setDeletePreviewIndex(index);
    }, []);
    const handleDeletePreviewEnd = (0, $cozmU.useCallback)(()=>{
        setDeletePreviewIndex(null);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const pendingDeleteFocus = pendingDeleteFocusRef.current; // Avoid focusing a stale pre-delete tab ref before the parent re-renders the shorter list.
        if (!pendingDeleteFocus || tabs.length !== pendingDeleteFocus.expectedTabsLength) return;
        const focusIndex = Math.min(pendingDeleteFocus.index, tabs.length - 1);
        if (focusIndex < 0 || activeIndex !== focusIndex) return;
        tabRefs.current[focusIndex]?.focus();
        pendingDeleteFocusRef.current = null;
    }, [
        activeIndex,
        tabs.length
    ]);
    (0, $cozmU.useEffect)(()=>{
        let innerRafId; // The first frame lets the appended tab update overflow state; the second
        // lets newly rendered scroll buttons shrink the tab-strip viewport before
        // we scroll the active tab into view.
        const outerRafId = requestAnimationFrame(()=>{
            innerRafId = requestAnimationFrame(()=>{
                const scrollContainer = scrollContainerRef.current;
                const activeTab = tabRefs.current[activeIndex];
                if (!scrollContainer || !activeTab) return;
                const scrollContainerRect = scrollContainer.getBoundingClientRect();
                const activeTabRect = activeTab.getBoundingClientRect();
                const endTarget = tabMenuRefs.current[activeIndex] ?? activeTab;
                const endTargetRect = endTarget.getBoundingClientRect();
                const startDelta = activeTabRect[axis.rectStart] - scrollContainerRect[axis.rectStart];
                const endDelta = endTargetRect[axis.rectEnd] - scrollContainerRect[axis.rectEnd];
                if (startDelta < 0) scrollContainer.scrollTo({
                    [axis.scrollKey]: Math.max(0, scrollContainer[axis.scrollPos] + startDelta - axis.scrollPadding),
                    behavior: 'smooth'
                });
                else if (endDelta > 0) scrollContainer.scrollTo({
                    [axis.scrollKey]: scrollContainer[axis.scrollPos] + endDelta + axis.scrollPadding,
                    behavior: 'smooth'
                });
            });
        });
        return ()=>{
            cancelAnimationFrame(outerRafId);
            if (innerRafId !== undefined) cancelAnimationFrame(innerRafId);
        };
    }, [
        activeIndex,
        axis,
        tabs.length
    ]);
    const handleDeleteTab = (0, $cozmU.useCallback)((index)=>{
        if (!onDeleteTab || index < 0 || index >= tabs.length || tabs.length <= 1) return;
        pendingDeleteFocusRef.current = {
            index: Math.min(index, tabs.length - 2),
            expectedTabsLength: tabs.length - 1
        };
        handleDeletePreviewEnd();
        onDeleteTab(index);
    }, [
        handleDeletePreviewEnd,
        onDeleteTab,
        tabs.length
    ]);
    const handleReorderKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (!canEdit || tabs.length === 0 || !event.ctrlKey || !event.altKey || event.shiftKey) return;
        const moveTab = event.key === axis.previousKey ? onMoveTabPrevious : event.key === axis.nextKey ? onMoveTabNext : undefined;
        if (!moveTab) return;
         // Capture reorder shortcuts before the title input stops propagation.
        // Keep unmodified arrows in the input for normal caret movement.
        event.preventDefault();
        event.stopPropagation();
        moveTab();
    }, [
        axis,
        canEdit,
        onMoveTabPrevious,
        onMoveTabNext,
        tabs.length
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (tabs.length === 0 || event.ctrlKey || event.altKey || event.metaKey || event.shiftKey) return;
        const { previousKey: previousKey, nextKey: nextKey } = axis;
        let nextIndex = null;
        if (event.key === nextKey) nextIndex = (activeIndex + 1) % tabs.length;
        else if (event.key === previousKey) nextIndex = (activeIndex - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        event.stopPropagation();
        focusTab(nextIndex, activeIndex);
    }, [
        activeIndex,
        tabs.length,
        focusTab,
        axis
    ]);
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const [scrollState, setScrollState] = (0, $cozmU.useState)({
        hasOverflow: false,
        canScrollBackward: false,
        canScrollForward: false
    });
    const updateScrollState = (0, $cozmU.useCallback)(()=>{
        const el = scrollContainerRef.current;
        if (!el) return;
        const scrollPosition = el[axis.scrollPos];
        const scrollSize = el[axis.scrollSize];
        const clientSize = el[axis.clientSize];
        setScrollState({
            hasOverflow: scrollSize > clientSize,
            canScrollBackward: scrollPosition > 0,
            // Use Math.ceil to handle sub-pixel rounding — scroll offsets can be floats.
            canScrollForward: Math.ceil(scrollPosition) < scrollSize - clientSize
        });
    }, [
        axis
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = scrollContainerRef.current;
        if (!el) return;
        updateScrollState();
        let rafId;
        const handleScroll = ()=>{
            if (rafId !== undefined) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(updateScrollState);
        };
        el.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return ()=>{
            el.removeEventListener('scroll', handleScroll);
            if (rafId !== undefined) cancelAnimationFrame(rafId);
        };
    }, [
        updateScrollState,
        tabs.length
    ]);
    const handleScrollPrevious = (0, $cozmU.useCallback)(()=>{
        const el = scrollContainerRef.current;
        if (!el) return;
        el.scrollTo?.({
            [axis.scrollKey]: el[axis.scrollPos] - el[axis.clientSize],
            behavior: 'smooth'
        });
    }, [
        axis
    ]);
    const handleScrollNext = (0, $cozmU.useCallback)(()=>{
        const el = scrollContainerRef.current;
        if (!el) return;
        el.scrollTo?.({
            [axis.scrollKey]: el[axis.scrollPos] + el[axis.clientSize],
            behavior: 'smooth'
        });
    }, [
        axis
    ]);
    (0, $cozmU.useEffect)(()=>{
        const scrollEl = scrollContainerRef.current;
        if (!scrollEl || !canEdit || !onReorderTabs) return;
        return (0, $4QfFX.combine)((0, $4Vdlk.monitorForElements)({
            canMonitor: ({ source: source })=>source.data.type === (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e) && source.data.instanceId === (instanceId ?? scrollContainerRef.current),
            onDragStart: ()=>{
                setIsDragging(true);
            },
            onDrop: ({ source: source, location: location })=>{
                setIsDragging(false);
                const currentInstanceId = instanceId ?? scrollContainerRef.current;
                const target = location.current.dropTargets.find((dropTarget)=>dropTarget.data.type === (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e) && typeof dropTarget.data.index === 'number' && dropTarget.data.instanceId === currentInstanceId);
                if (!target) return;
                const sourceIndex = source.data.index;
                const targetIndex = target.data.index;
                const edge = (0, $ez93V.extractClosestEdge)(target.data);
                if (edge) {
                    const scrollOffset = captureScrollOffset();
                    onReorderTabs(sourceIndex, targetIndex, edge);
                    restoreScrollOffset(scrollOffset);
                }
            }
        }), (0, $38vK5.autoScrollForElements)({
            element: scrollEl,
            canScroll: ({ source: source })=>source.data.type === (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e) && source.data.instanceId === (instanceId ?? scrollContainerRef.current)
        }));
    }, [
        canEdit,
        captureScrollOffset,
        onReorderTabs,
        restoreScrollOffset,
        instanceId
    ]);
    const showMenuButton = canEdit && tabs.length > 0;
    const ownedTabIds = tabs.map((tab)=>tab.id).join(' ');
    const activeEditingTabId = tabs[activeIndex]?.id === editingTabId ? editingTabId : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5644460bd08617e5$var$styles.tabBarRow, orientation === 'vertical' && $5644460bd08617e5$var$styles.tabBarColumn)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.srOnly,
        role: "tablist",
        "aria-label": formatMessage($5644460bd08617e5$var$i18n.tablistLabel),
        "aria-orientation": orientation,
        "aria-owns": ownedTabIds || undefined,
        testId: "native-tabs-tab-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5644460bd08617e5$var$styles.scrollContainerWrapper, orientation === 'vertical' && $5644460bd08617e5$var$styles.scrollContainerWrapperVertical)
    }, orientation === 'horizontal' && scrollState.canScrollBackward && !isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.scrollFadeLeft,
        "aria-hidden": "true",
        testId: "native-tabs-scroll-fade-left"
    }), orientation === 'vertical' && scrollState.canScrollBackward && !isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.scrollFadeTop,
        "aria-hidden": "true",
        testId: "native-tabs-scroll-fade-top"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: scrollContainerRef,
        xcss: (0, $w6R6I.cx)($5644460bd08617e5$var$styles.scrollContainer, orientation === 'vertical' && $5644460bd08617e5$var$styles.scrollContainerVertical),
        as: "div",
        testId: "native-tabs-scroll-container",
        contentEditable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onKeyDownCapture: handleReorderKeyDown,
        onKeyDown: handleKeyDown,
        tabIndex: -1,
        xcss: $5644460bd08617e5$var$styles.overflowVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5644460bd08617e5$var$styles.tabItems, orientation === 'vertical' && $5644460bd08617e5$var$styles.tabItemsVertical)
    }, tabs.map((tab, index)=>{
        const isActive = index === activeIndex;
        const showPillMenuButton = isActive && showMenuButton;
        const isDeletePreviewed = deletePreviewIndex === index;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: tab.id,
            xcss: (0, $w6R6I.cx)($5644460bd08617e5$var$styles.tabPillItem, orientation === 'vertical' && $5644460bd08617e5$var$styles.tabPillItemVertical)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5644460bd08617e5$var$TabBarItem, {
            tab: tab,
            index: index,
            isActive: isActive,
            showMenuButton: showPillMenuButton,
            canDrag: canDrag,
            orientation: orientation,
            registerRef: registerRef,
            registerMenuRef: registerMenuRef,
            onSelect: onTabClick,
            onEmojiPickerOpen: onEmojiPickerOpen,
            onRemoveEmoji: onRemoveEmoji,
            isEmojiPickerOpen: isEmojiPickerOpen,
            onEmojiPickerClose: onEmojiPickerClose,
            emojiPickerContent: emojiPickerContent,
            emojiProvider: emojiProvider,
            onMoveTabPrevious: onMoveTabPrevious,
            onMoveTabNext: onMoveTabNext,
            onCopyLink: onCopyLink,
            onDeleteTab: handleDeleteTab,
            canRename: isActive && canEdit,
            editingTabId: activeEditingTabId,
            onTitleEditStart: handleTitleEditStart,
            onTitleEditSave: handleTitleEditSave,
            onTitleEditCancel: handleTitleEditCancel,
            isFirst: index === 0,
            isLast: index === tabs.length - 1,
            isDeletePreviewed: isDeletePreviewed,
            onDeletePreviewStart: handleDeletePreviewStart,
            onDeletePreviewEnd: handleDeletePreviewEnd,
            scrollContainerRef: scrollContainerRef,
            externalInstanceId: instanceId,
            registerPillWrapper: registerPillWrapper,
            onColorChange: onColorChange,
            applyToAll: applyToAll,
            onApplyToAllChange: onApplyToAllChange,
            contentAreaEdge: contentAreaDrop?.index === index ? contentAreaDrop.edge : null
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
        key: orientation,
        setWidth: updateScrollState,
        offscreen: true
    })), orientation === 'horizontal' && scrollState.canScrollForward && !isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.scrollFadeRight,
        "aria-hidden": "true",
        testId: "native-tabs-scroll-fade"
    }), orientation === 'vertical' && scrollState.canScrollForward && !isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.scrollFadeBottom,
        "aria-hidden": "true",
        testId: "native-tabs-scroll-fade-bottom"
    })), canEdit && onAddTab ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5644460bd08617e5$var$styles.addTabButton, orientation === 'vertical' && $5644460bd08617e5$var$styles.addTabButtonVertical)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
        label: formatMessage($5644460bd08617e5$var$i18n.addTab),
        isTooltipDisabled: false,
        onClick: onAddTab
    })) : null, orientation === 'horizontal' && scrollState.hasOverflow && !isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.navButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))),
        label: formatMessage($5644460bd08617e5$var$i18n.scrollTabsLeft),
        isDisabled: !scrollState.canScrollBackward,
        onClick: handleScrollPrevious
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.navButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
        label: formatMessage($5644460bd08617e5$var$i18n.scrollTabsRight),
        isDisabled: !scrollState.canScrollForward,
        onClick: handleScrollNext
    }))), orientation === 'vertical' && scrollState.hasOverflow && !isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5644460bd08617e5$var$styles.verticalNavGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: formatMessage($5644460bd08617e5$var$i18n.scrollTabsUp),
        isDisabled: !scrollState.canScrollBackward,
        onClick: handleScrollPrevious
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
        label: formatMessage($5644460bd08617e5$var$i18n.scrollTabsDown),
        isDisabled: !scrollState.canScrollForward,
        onClick: handleScrollNext
    })));
};
$5644460bd08617e5$export$f97dc4a5a0177256.displayName = 'TabBar';


const $cf57be11cff62dee$var$styles = {
    shell: "_39xV02N91d",
    layout: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d",
    verticalLayout: "_0aFT5v1qpb _0hPCNLFlnN",
    verticalPanel: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4ouGXIdnbC _46hvQm2ADO"
}; // The editor-owned descendants have no styling props. Compiled supports the scoped
// descendant selectors that the restricted @atlaskit/css types cannot express.
const $cf57be11cff62dee$var$editorStyles = {
    verticalEditorPanel: "_3iDTPbQ4SZ _0aFT5vbt8w _0vznXXQ4SZ _4v6Tfsbt8w _4DV2Ea7dHp _1XBnz3Q4SZ _2iDEvybt8w _1OQyh47dHp _26qFr87dHp"
};
const $cf57be11cff62dee$export$54833456b709a818 = ({ tabs: tabs, activeIndex: activeIndex, onTabClick: onTabClick, onAddTab: onAddTab, onRenameTab: onRenameTab, canEdit: canEdit, orientation: orientation = 'horizontal', onReorderTabs: onReorderTabs, onMoveTabPrevious: onMoveTabPrevious, onMoveTabNext: onMoveTabNext, onCopyLink: onCopyLink, onDeleteTab: onDeleteTab, onEmojiPickerOpen: onEmojiPickerOpen, onRemoveEmoji: onRemoveEmoji, isEmojiPickerOpen: isEmojiPickerOpen = false, onEmojiPickerClose: onEmojiPickerClose, emojiPickerContent: emojiPickerContent = null, emojiProvider: emojiProvider, onColorChange: onColorChange, applyToAll: applyToAll = false, onApplyToAllChange: onApplyToAllChange, rootRef: rootRef, activeFrame: activeFrame })=>{
    const axis = (0, $k6Q5P.getTabAxis)(orientation);
    const activeTab = tabs[activeIndex];
    const internalRef = (0, $cozmU.useRef)(null);
    const shellRef = rootRef ?? internalRef; // Stable identity object shared with TabBar to scope drags to this instance.
    const instanceIdRef = (0, $cozmU.useRef)({});
    const [contentAreaDrop, setContentAreaDrop] = (0, $cozmU.useState)(null); // Registry of pill wrapper elements, populated by TabBar via registerPillWrapper.
    const pillWrappersRef = (0, $cozmU.useRef)([]);
    const registerPillWrapper = (0, $cozmU.useCallback)((index, element)=>{
        pillWrappersRef.current[index] = element;
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const el = shellRef.current;
        if (!el || !canEdit || !onReorderTabs) return;
         // Track the latest computed drop position so the onDrop callback can use it.
        const latestDrop = {
            current: null
        };
        const instanceId = instanceIdRef.current;
        return (0, $4QfFX.combine)(// Catch-all drop target on the shell so the expanded content-area
        // drop detection works — provides a valid drop zone when the cursor
        // is outside individual pill targets.
        (0, $4Vdlk.dropTargetForElements)({
            element: el,
            canDrop: ({ source: source })=>source.data.type === (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e) && source.data.instanceId === instanceId,
            getData: ()=>({
                    type: (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e)
                })
        }), (0, $4Vdlk.monitorForElements)({
            canMonitor: ({ source: source })=>source.data.type === (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e) && source.data.instanceId === instanceId,
            onDrag: ({ source: source, location: location })=>{
                // When the cursor is directly over a pill-level drop target,
                // that target handles the indicator — clear the content-area state.
                const overPillTarget = location.current.dropTargets.find((t)=>t.data.type === (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e) && typeof t.data.index === 'number');
                if (overPillTarget) {
                    latestDrop.current = null;
                    setContentAreaDrop(null);
                    return;
                } // Cursor is outside all pill targets — compute the closest pill edge
                // along the navigation axis.
                const result = (0, $c59ce8ad53c75e90$export$352e4484cda9b022)(location.current.input[axis.pointer], pillWrappersRef.current, orientation);
                if (result && result.index !== source.data.index) {
                    latestDrop.current = result;
                    setContentAreaDrop((prev)=>prev?.index === result.index && prev?.edge === result.edge ? prev : result);
                } else {
                    latestDrop.current = null;
                    setContentAreaDrop(null);
                }
            },
            onDrop: ({ source: source, location: location })=>{
                // If the drop landed on a pill-level target, TabBar's own monitor handles it.
                // Only handle drops that land outside pill targets (content area / outside).
                const overPillTarget = location.current.dropTargets.find((t)=>t.data.type === (0, $c59ce8ad53c75e90$export$f49ff9a54a0d489e) && typeof t.data.index === 'number');
                if (!overPillTarget) {
                    const drop = latestDrop.current;
                    if (drop) {
                        const sourceIndex = source.data.index;
                        onReorderTabs(sourceIndex, drop.index, drop.edge);
                    }
                }
                latestDrop.current = null;
                setContentAreaDrop(null);
            }
        }));
    }, [
        axis,
        canEdit,
        onReorderTabs,
        orientation,
        shellRef
    ]);
    const tabBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5644460bd08617e5$export$f97dc4a5a0177256), {
        tabs: tabs,
        activeIndex: activeIndex,
        onTabClick: onTabClick,
        onAddTab: onAddTab,
        onRenameTab: onRenameTab,
        canEdit: canEdit,
        orientation: orientation,
        onReorderTabs: onReorderTabs,
        onMoveTabPrevious: onMoveTabPrevious,
        onMoveTabNext: onMoveTabNext,
        onCopyLink: onCopyLink,
        onDeleteTab: onDeleteTab,
        onEmojiPickerOpen: onEmojiPickerOpen,
        onRemoveEmoji: onRemoveEmoji,
        isEmojiPickerOpen: isEmojiPickerOpen,
        onEmojiPickerClose: onEmojiPickerClose,
        emojiPickerContent: emojiPickerContent,
        emojiProvider: emojiProvider,
        onColorChange: onColorChange,
        applyToAll: applyToAll,
        onApplyToAllChange: onApplyToAllChange,
        contentAreaDrop: contentAreaDrop,
        instanceId: instanceIdRef.current,
        registerPillWrapper: registerPillWrapper
    });
    const panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "tabpanel",
        id: activeTab ? `panel-${activeTab.id}` : undefined,
        "aria-labelledby": activeTab?.id,
        testId: "native-tabs-panel",
        xcss: (0, $w6R6I.cx)(orientation === 'vertical' && $cf57be11cff62dee$var$styles.verticalPanel, orientation === 'vertical' && canEdit && $cf57be11cff62dee$var$editorStyles.verticalEditorPanel)
    }, activeFrame);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: shellRef,
        xcss: $cf57be11cff62dee$var$styles.shell,
        testId: "native-tabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($cf57be11cff62dee$var$styles.layout, orientation === 'vertical' && $cf57be11cff62dee$var$styles.verticalLayout)
    }, tabBar, panel));
};
$cf57be11cff62dee$export$54833456b709a818.displayName = 'NativeTabs';
module.exports["NativeTabs"] = $cf57be11cff62dee$export$54833456b709a818;

});

parcelRegister("k6Q5P", function(module, exports) {
const $6186b63ae76a4f41$var$axes = {
    horizontal: {
        startEdge: 'left',
        endEdge: 'right',
        previousKey: 'ArrowLeft',
        nextKey: 'ArrowRight',
        pointer: 'clientX',
        rectStart: 'left',
        rectEnd: 'right',
        scrollPos: 'scrollLeft',
        scrollSize: 'scrollWidth',
        clientSize: 'clientWidth',
        scrollKey: 'left',
        scrollPadding: 30
    },
    vertical: {
        startEdge: 'top',
        endEdge: 'bottom',
        previousKey: 'ArrowUp',
        nextKey: 'ArrowDown',
        pointer: 'clientY',
        rectStart: 'top',
        rectEnd: 'bottom',
        scrollPos: 'scrollTop',
        scrollSize: 'scrollHeight',
        clientSize: 'clientHeight',
        scrollKey: 'top',
        scrollPadding: 0
    }
};
const $6186b63ae76a4f41$export$bb9844769887753 = (orientation)=>$6186b63ae76a4f41$var$axes[orientation];
module.exports["getTabAxis"] = $6186b63ae76a4f41$export$bb9844769887753;

});

parcelRegister("ihDzO", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");


var $6mKj3 = parcelRequire("6mKj3");

const $688d2e2fb438c465$export$38f778daa75718c8 = ()=>(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && (0, $6mKj3.expVal)('confluence_native_tabs_m15', 'isEnabled', false);
module.exports["isStandardTabColorPaletteEnabled"] = $688d2e2fb438c465$export$38f778daa75718c8;

});


//# sourceMappingURL=TabsRenderer.e14b2f4e.js.map
